import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { CustomFormsModule } from 'ngx-custom-validators';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { HttpModule } from '@angular/http';
import { RouterModule, Router } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Component } from '@angular/core';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ngfModule, ngf } from "angular-file"
import { DragulaModule } from 'ng2-dragula';
import { CookieService } from 'ngx-cookie-service';
import { NgxEditorModule } from 'ngx-editor';
import { CKEditorModule } from 'ng2-ckeditor';
import { AppComponent } from './app.component';
import { ModalModule, BsDatepickerModule, PaginationModule   } from 'ngx-bootstrap';
import { DataTableModule } from "angular-6-datatable";
import { HttpClientModule } from '@angular/common/http';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { NavMenuComponent } from './ui-components/nav-menu/nav-menu.component';
import { SideNavComponent } from './ui-components/side-nav/side-nav.component';
import { NavProfileComponent } from './ui-components/nav-profile/nav-profile.component';
import { TopNavNotificationComponent } from './ui-components/top-nav-notification/top-nav-notification.component';
import { HomeComponent } from './home/home.component';
import { HomeService } from './services/home/home.service';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { CartComponent } from './cart/cart.component';
import { HeaderSearchComponent } from './shared-components/header-search/header-search.component';
import { CategoryMenuItemsComponent } from './ui-components/category-menu-items/category-menu-items.component';
import { LoginComponent } from './login/login.component';
import { FaqListComponent } from './faq-components/faq-list/faq-list.component';
import { CreateSettingComponent } from './system-setting-component/create-setting/create-setting.component';
import { EditSettingComponent } from './system-setting-component/edit-setting/edit-setting.component';
import { SettingListComponent } from './system-setting-component/setting-list/setting-list.component';
import { SystemSettingService } from './services/system-settings/system-setting.service';
import { UpdateApplicationSettingsComponent } from './system-setting-component/update-application-settings/update-application-settings.component';
import { ApplicationSettingsService } from './services/system-settings/application-setting';
import { PagerService } from './services/shared/pager.service';
import { UtilitiesService } from './services/shared/utilities.service';
import { ForgotPasswordComponent } from './login/forgotPassword/ForgotPassword.component';
import { FaqService } from './services/faq/faq.service';
import { CreateFaqComponent } from './faq-components/create-faq/create-faq.component';
import { EditFaqComponent } from './faq-components/edit-faq/edit-faq.component';
import { CreateParentCategoryComponent } from './category-components/parent-category/create-parent-category/create-parent-category.component';
import { EditParentCategoryComponent } from './category-components/parent-category/edit-parent-category/edit-parent-category.component';
import { ParentCategoryListComponent } from './category-components/parent-category/parent-category-list/parent-category-list.component';
import { CategoryService } from './services/category/category.service';
import { CreateProductComponent } from './product-components/create-product/create-product.component';
import { EditProductComponent } from './product-components/edit-product/edit-product.component';
import { DeleteProductComponent } from './product-components/delete-product/delete-product.component';
import { ProductListComponent } from './product-components/product-list/product-list.component';
import { ProductService } from './services/product/product.service';
import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { DiscountTypeListComponent } from './coupons/discount-type/discount-type-list/discount-type-list.component';
import { CreateDiscountTypeComponent } from './coupons/discount-type/create-discount-type/create-discount-type.component';
import { EditDiscountTypeComponent } from './coupons/discount-type/edit-discount-type/edit-discount-type.component';
import { DiscountTypeService } from './services/coupons/discount-type.service';
import { MediaLibraryService } from './services/mediaLibrary/media-library.service';
import { MediaLibraryListComponent } from './mediaLibrary-components/media-library-list/media-library-list.component';

import { ResetPasswordComponent } from './login/resetPassword/resetPassword.component';
//import { CouponTypeListComponent } from './coupons/coupon-type/coupon-type-list/coupon-type-list.component';
//import { CreateCouponTypeComponent } from './coupons/coupon-type/create-coupon-type/create-coupon-type.component';
//import { EditCouponTypeComponent } from './coupons/coupon-type/edit-coupon-type/edit-coupon-type.component';
//import { CouponTypeService } from './services/coupons/coupon-type.service';

import { CouponsListComponent } from './coupons/coupons/coupons-list/coupons-list.component';
import { CreateCouponComponent } from './coupons/coupons/create-coupon/create-coupon.component';
import { EditCouponComponent } from './coupons/coupons/edit-coupon/edit-coupon.component';
import { CouponsService } from './services/coupons/coupons.service';

//import { CouponCategoryProductListComponent } from './coupons/coupon-category-product/coupon-category-product-list/coupon-category-product-list.component';
//import { CreateCouponCategoryProductComponent } from './coupons/coupon-category-product/create-coupon-category-product/create-coupon-category-product.component';
//import { EditCouponCategoryProductComponent } from './coupons/coupon-category-product/edit-coupon-category-product/edit-coupon-category-product.component';
//import { CouponCategoryProductService } from './services/coupons/coupon-category-product.service';

import { CategoryListComponent } from './category-components/category/category-list/category-list.component';
import { CreateSubcategoryComponent } from './category-components/subcategory/create-subcategory/create-subcategory.component';
import { SubcategoryListComponent } from './category-components/subcategory/subcategory-list/subcategory-list.component';
import { EditSubcategoryComponent } from './category-components/subcategory/edit-subcategory/edit-subcategory.component';
import { FieldErrorDisplayComponent } from './field-error-display/field-error-display.component';

import { CustomerListComponent } from './customer-components/customer-list/customer-list.component'; 

import { CreateCustomerComponent } from './customer-components/create-customer/create-customer.component';
import { EditCustomerComponent } from './customer-components/edit-customer/edit-customer.component';
import { CustomerDetailComponent } from './customer-components/customer-detail/customer-detail.component';
import { CustomerService } from './services/customer/customer.service';
import { CategorySalesComponent } from './category-components/category-sales/category-sales.component';

import { CountryService } from './services/country/country.service';
import { StateService } from './services/state/state.service';


import { UserListComponent } from './user-components/user-list/user-list.component';
import { UserCreateComponent } from './user-components/user-create/user-create.component';
import { UserEditComponent } from './user-components/user-edit/user-edit.component';
import { UserService } from './services/user/user.service';

import { ProfileViewComponent } from './profile-components/profile-view/profile-view.component';
import { ProfileUpdateComponent } from './profile-components/profile-update/profile-update.component';
import { ProfileService } from './services/profile/profile.service';

import { FaqCategoryService } from './services/faq/faq-category.service';
import { CreateFaqCategoryComponent } from './faq-components/create-faq-category/create-faq-category.component';
import { DetailFaqComponent } from './faq-components/detail-faq/detail-faq.component';
import { DetailFaqCategoryComponent } from './faq-components/detail-faq-category/detail-faq-category.component';
import { EditFaqCategoryComponent } from './faq-components/edit-faq-category/edit-faq-category.component';
import { FaqCategoryListComponent } from './faq-components/faq-category-list/faq-category-list.component';

import { CategoryFieldsComponent } from './category-components/category-fields/category-fields.component';

import { CreateNotificationComponent } from './notification-components/create-notification/create-notification.component';
import { NotificationService } from './services/notification/notification.service';
import { NotificationListComponent } from './notification-components/notification-list/notification-list.component';
import { EditNotificationComponent } from './notification-components/edit-notification/edit-notification.component';

import { CreateNotificationEventComponent } from './event-components/create-notification-event/create-notification-event.component';
import { NotificationEventListComponent } from './event-components/notification-event-list/notification-event-list.component';
import { NotificationEventService } from './services/event/notification-event.service';
import { EditNotificationEventComponent } from './event-components/edit-notification-event/edit-notification-event.component';

import { CreateRoleComponent } from './role-components/create-role/create-role.component';
import { EditRoleComponent } from './role-components/edit-role/edit-role.component';
import { RoleListComponent } from './role-components/role-list/role-list.component';
import { RolePermissionsComponent } from './role-components/role-permissions/role-permissions.component';
import { RoleService } from './services/role/role.service';
import { RolePermissionService } from './services/role/role-permission.service';

import { LoginService } from './services/login/login.service';
import { AppService } from './services/app/app.service';
import { TimeAgoPipe } from 'time-ago-pipe';

import { PushNotificationComponent } from './notification-components/push-notification/push-notification.component';
import { PushNotificationService } from './services/notification/push-notification.service';
import { SubscriberService } from './services/others/subscriber.service';
import { SubscriberListComponent } from './subscribers/subscriber-list/subscriber-list.component';
import { EditSubscribersComponent } from './subscribers/edit-subscribers/edit-subscribers.component';
import { StoreListComponent } from './store-components/store-list/store-list.component';
import { StoreService } from './services/store/store.service';

import { CreateBrandComponent } from './brand/create-brand/create-brand.component';
import { BrandService } from './services/brand/brand.service';
import { BrandListComponent } from './brand/brand-list/brand-list.component';
import { EditBrandComponent } from './brand/edit-brand/edit-brand.component';
import { EditShippmentMethodComponent } from './shipping-components/edit-shippment-method/edit-shippment-method.component';
import { CreateShippingMethodComponent } from './shipping-components/create-shipping-method/create-shipping-method.component';
import { ShippingMethodsListComponent } from './shipping-components/shipping-methods-list/shipping-methods-list.component';
import { ShippmentService } from './services/shippment/shippment-setting'
import { CreateAnnouncementComponent } from './announcement-components/create-announcement/create-announcement.component';
import { EditAnnouncementComponent } from './announcement-components/edit-announcement/edit-announcement.component';
import { AnnouncementListComponent } from './announcement-components/announcement-list/announcement-list.component';
import { AnnouncementService } from './services/announcement/announcement.service';
import { CreatePaymentMethodComponent } from './payment-components/create-payment-method/create-payment-method.component';
import { PaymentService } from './services/payment/payment.service';
import { PaymentMethodListComponent } from './payment-components/payment-method-list/payment-method-list.component';
import { EditPaymentMethodComponent } from './payment-components/edit-payment-method/edit-payment-method.component';
import { RatingListComponent } from './ratings/rating-list/rating-list.component';
import { RatingService } from './services/rating/rating.service';

import { CreateActionNotificationComponent } from './notification-components/action-based-notifications/create-action-notification/create-action-notification.component';
import { EditActionNotificationComponent } from './notification-components/action-based-notifications/edit-action-notification/edit-action-notification.component';
import { ActionNotificationListComponent } from './notification-components/action-based-notifications/action-notification-list/action-notification-list.component';
import { ActionNotificationService } from './services/notification/action-notification.service';
import { CategorySalesListComponent } from './category-components/category-sales-list/category-sales-list.component';
import { EditCategoryLevelSalesComponent } from './category-components/edit-category-level-sales/edit-category-level-sales.component';
import { BannerSliderService } from './services/BannerSlider/BannerSlider.service';
import { CreateBannerSliderComponent } from './BannerSlider/create-BannerSlider/create-BannerSlider.component';
import { BannerSliderListComponent } from './BannerSlider/BannerSlider-list/BannerSlider-list.component';
import { EditBannerSliderComponent } from './BannerSlider/edit-BannerSlider/edit-BannerSlider.component';

import { OrderListComponent } from './order-components/order-list/order-list.component';
import { OrderDetailComponent } from './order-components/order-detail/order-detail.component';
import { OrderService } from './services/order/order.service';
import { BlogCategoryService } from './services/blog/blog-category.service';
import { CreateBlogCategoryComponent } from './blog-components/create-blog-category/create-blog-category.component';
import { BlogcategoryListComponent } from './blog-components/blogcategory-list/blogcategory-list.component';
import { EditBlogCategoryComponent } from './blog-components/edit-blog-category/edit-blog-category.component';
import { CreateBlogComponent } from './blog-components/create-blog/create-blog.component';
import { BlogListComponent } from './blog-components/blog-list/blog-list.component';
import { EditBlogComponent } from './blog-components/edit-blog/edit-blog.component'; 

import { PurchaseOrderListComponent } from './order-components/purchase-order-list/purchase-order-list.component';
import { PurchaseOrderDetailComponent } from './order-components/purchase-order-detail/purchase-order-detail.component';
import { PurchaseOrdersComponent } from './order-components/purchase-orders/purchase-orders.component';
import { PurchaseOrderService } from './services/purchase-order/purchase-order.service'

import { AddShippingCostComponent } from './shipping-components/add-shipping-cost/add-shipping-cost.component';
import {ShippingCostService } from './services/shippment/shipping-cost.service';

import { CreateEmailTemplateComponent } from './EmailTemplate/create-EmailTemplate/create-EmailTemplate.component';
import { EmailTemplateService } from './services/EmailTemplate/EmailTemplate.service';
import { EmailTemplateListComponent } from './EmailTemplate/EmailTemplate-list/EmailTemplate-list.component';
import { EditEmailTemplateComponent } from './EmailTemplate/edit-EmailTemplate/edit-EmailTemplate.component';
 
import { CetogoryMenuComponent } from './cetogory-menu-management/cetogory-menu-management';
 
import { ManageUrlRedirectionComponent } from './url-redirection/manage-url-redirection/manage-url-redirection.component';
import { UrlRedirectionService } from './services/url-redirection/url-redirection.service';
import { DecimalNumberService } from './services/shared/decimal-number.service';
import { AttributesComponent } from './product-components/attributes/attributes.component';
import { SlugComponent } from './product-components/slug/slug.component';
import { CreatePageComponent } from './static-page/create-page/create-page.component';
import { PageService } from './services/static-page/page.service';
import { PageListComponent } from './static-page/page-list/page-list.component';
import { EditPageComponent } from './static-page/edit-page/edit-page.component';
import { SupplierTicketService } from './services/SupplierTicket/SupplierTicket.service';
import { SupplierTicketListComponent } from './SupplierTicket/SupplierTicket-list/SupplierTicket-list.component';
 

import { EditSimpleProductComponent } from './product-components/edit-simple-product/edit-simple-product.component';
import { EditVariableProductComponent } from './product-components/edit-variable-product/edit-variable-product.component';
 
import { SettingShipmentRulesListComponent } from './SettingShipmentRules/SettingShipmentRules-list/SettingShipmentRules-list.component';
import { SettingShipmentRulesService } from './services/SettingShipmentRules/SettingShipmentRules.service';

import { CreatePageWidgetComponent } from './widget/create-page-widget/create-page-widget.component';
import { WidgetService } from './services/widget/widget.service';
import { PageWidgetListComponent } from './widget/page-widget-list/page-widget-list.component';


import { SiteMapsService } from './services/sitemap/site-maps.service';
import { SiteMapsComponent } from './sitemaps/site-maps/site-maps.component';
import { CreateManuManagementComponent } from './manu-management-component/create-manu-management/create-manu-management.component';
import { ManuManagementService } from './services/manu-mangement/manu-management.service';
import { ManuManagementListComponent } from './manu-management-component/manu-management-list/manu-management-list.component';
import { EditMenuManagementComponent } from './manu-management-component/edit-menu-management/edit-menu-management.component'; 

import { WithdrawlsService } from './services/withdrawls/withdrawls.service';
import { FinanceManagementListComponent } from './finance-management/finance-management-list/finance-management-list.component';
import { WithdrawalRequestComponent } from './finance-management/withdrawal-request/withdrawal-request.component';
import { WithdrawalDetailsComponent } from './finance-management/withdrawal-details/withdrawal-details.component';

import { ProductImportComponent } from './product-components/product-import/product-import.component';
import { NgxSortableModule } from 'ngx-sortable';
import { SortPageWidgetsComponent } from './widget/sort-widgets/sort-page-widgets/sort-page-widgets.component';
import { ParentSortWidgetsComponent } from './widget/sort-widgets/parent-sort-widgets/parent-sort-widgets.component';
import { EditPageWidgetComponent } from './widget/edit-page-widget/edit-page-widget.component';
import { ReadMoreComponent } from './shared-components/read-more/read-more.component';
import { WarrantyCreateComponent } from './warrantyType/warranty-create/warranty-create.component';
import { WarrantyTypeListComponent } from './warrantyType/warranty-type-list/warranty-type-list.component';
import { WarrantyEditComponent } from './warrantyType/warranty-edit/warranty-edit.component';
import { ReturnPolicyCreateComponent } from './return-policy/return-policy-create/return-policy-create.component';
import { ReturnPolicyListComponent } from './return-policy/return-policy-list/return-policy-list.component';
import { ReturnPolicyEditComponent } from './return-policy/return-policy-edit/return-policy-edit.component';
import { EditDraftProductComponent } from './product-components/edit-draft-product/edit-draft-product.component';
import { SplitStringPipe } from './custom-pipes/split-string.pipe';
import { LowerCase } from './custom-pipes/lowerCase.pipe';
import { GenericService } from './services/generic.service'; 
import { RptVendorsComponent } from './Reports/rpt-vendors/rpt-vendors.component'; 
import { RptSalesComponent } from './Reports/rpt-sales/rpt-sales.component'; 
import { ReportService } from './services/report/report.service';   
import { RptSearchHistoryComponent } from './Reports/rpt-search-history/rpt-search-history.component';
 
import { RptCustomerOrdersComponent } from './Reports/rpt-customer-orders/rpt-customer-orders.component';
import { RptShipmentComponent } from './Reports/rpt-shipment/rpt-shipment.component'; 
import { RptCustomerComponent } from './Reports/rpt-customer/rpt-customer.component';
import { PopupNotificationComponent } from './notification-components/popup-notification/popup-notification.component';
import { PopupNotificationListComponent } from './notification-components/popup-notification-list/popup-notification-list.component';
import { EditPopupNotificationComponent } from './notification-components/edit-popup-notification/edit-popup-notification.component';
// Mobile page widgets components and service
import { CreateMobilePageWidgetComponent } from './widget-mobile/create-mobile-page-widget/create-mobile-page-widget.component';
import { MobilePageWidgetListComponent } from './widget-mobile/mobile-page-widget-list/mobile-page-widget-list.component';
import { EditMobilePageWidgetComponent } from './widget-mobile/edit-mobile-page-widget/edit-mobile-page-widget.component';
import { MobilewidgetService } from './services/widget/mobilewidget.service';
import { SafeHtmlPipe } from './custom-pipes/safe-html.pipe'; 
import { SelectDropDownModule } from 'ngx-select-dropdown';

import { SinglePoReportComponent } from './order-components/single-po-report/single-po-report.component'
import { MultiPoReportComponent } from './order-components/multi-po-report/multi-po-report.component'
import { SelectModule } from 'ng2-select';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

@NgModule({
  declarations: [
    RptCustomerComponent,
    AppComponent,
    NavMenuComponent,
    SideNavComponent,
    RptVendorsComponent,
    CetogoryMenuComponent,
    TopNavNotificationComponent,
    NavProfileComponent,
    HomeComponent,
    CounterComponent,
    FetchDataComponent,
    CartComponent,
    HeaderSearchComponent,
    CategoryMenuItemsComponent,
    LoginComponent,
    FaqListComponent,
    RptCustomerOrdersComponent,
    CreateSettingComponent,
    EditSettingComponent,
    SettingListComponent,
    CreateFaqComponent,
    EditFaqComponent,
    ForgotPasswordComponent,
    DiscountTypeListComponent,
    RolePermissionsComponent,
    CreateDiscountTypeComponent,
    EditDiscountTypeComponent,
    ResetPasswordComponent,
    CouponsListComponent,
    CreateCouponComponent,
    EditCouponComponent,
    CreateParentCategoryComponent,
    EditParentCategoryComponent,
    ParentCategoryListComponent,
    CreateProductComponent,
    EditProductComponent,
    DeleteProductComponent,
    ProductListComponent,
    CustomerListComponent,
    CreateCustomerComponent,
    EditCustomerComponent,
    CustomerDetailComponent,
    CategoryListComponent,
    CreateSubcategoryComponent,
    SubcategoryListComponent,
    EditSubcategoryComponent,
    FieldErrorDisplayComponent,
    CreateFaqCategoryComponent,
    EditFaqCategoryComponent,
    DetailFaqCategoryComponent,
    FaqCategoryListComponent,
    DetailFaqComponent,
    CreateNotificationComponent,
    NotificationListComponent,
    EditNotificationComponent,
    CategoryFieldsComponent,
    CreateNotificationEventComponent,
    NotificationEventListComponent,
    EditNotificationEventComponent,
    CreateRoleComponent,
    EditRoleComponent,
    RoleListComponent,
    TimeAgoPipe,
    UserListComponent,
    UserCreateComponent,
    UserEditComponent,
    UpdateApplicationSettingsComponent,
    CreateRoleComponent,
    PushNotificationComponent,
    SubscriberListComponent,
    EditSubscribersComponent,
    StoreListComponent,
    CreateBrandComponent,
    BrandListComponent,
    EditBrandComponent,
    ShippingMethodsListComponent,
    SiteMapsComponent,
    ProfileViewComponent,
    ProfileUpdateComponent,
    CreateAnnouncementComponent,
    EditAnnouncementComponent,
    AnnouncementListComponent,
    CreatePaymentMethodComponent,
    PaymentMethodListComponent,
    EditPaymentMethodComponent,
    CreateActionNotificationComponent,
    EditActionNotificationComponent,
    ActionNotificationListComponent,
    RatingListComponent,
    OrderListComponent,
    PurchaseOrderListComponent,
    PurchaseOrderDetailComponent,
    PurchaseOrdersComponent,
    OrderDetailComponent,
    CategorySalesComponent,
    CategorySalesListComponent,
    EditCategoryLevelSalesComponent,
    CreateBlogCategoryComponent,
    BlogcategoryListComponent,
    EditBlogCategoryComponent,
    CreateBlogComponent,
    BlogListComponent,
    EditBlogComponent,
    CreateEmailTemplateComponent,
    EmailTemplateListComponent,
    EditEmailTemplateComponent,
    CreateBannerSliderComponent,
    BannerSliderListComponent,
    EditBannerSliderComponent,
    AddShippingCostComponent,
    AddShippingCostComponent,
    CreateBlogCategoryComponent,
    BlogcategoryListComponent,
    EditBlogCategoryComponent,
    CreateBlogComponent,
    BlogListComponent,
    EditBlogComponent,
    AttributesComponent,
    SlugComponent,
    CreatePageComponent,
    PageListComponent,
    EditPageComponent,
    SupplierTicketListComponent,
    ManageUrlRedirectionComponent,
    SettingShipmentRulesListComponent,
    DecimalNumberService,
    EditSimpleProductComponent,
    EditVariableProductComponent,
    CreatePageWidgetComponent,
    PageWidgetListComponent,
    MediaLibraryListComponent,
    CreateShippingMethodComponent,
    EditShippmentMethodComponent,
    ProductImportComponent,
    CreateManuManagementComponent,
    ManuManagementListComponent,
    EditMenuManagementComponent,
    FinanceManagementListComponent,
    WithdrawalRequestComponent,
    WithdrawalDetailsComponent,
    SortPageWidgetsComponent,
    ParentSortWidgetsComponent,
    EditPageWidgetComponent,
    ReadMoreComponent,
    WarrantyCreateComponent,
    WarrantyTypeListComponent,
    WarrantyEditComponent,
    ReturnPolicyCreateComponent,
    ReturnPolicyListComponent,
    ReturnPolicyEditComponent,
    EditDraftProductComponent,
    RptSalesComponent,
    SplitStringPipe,
    LowerCase,
    RptSearchHistoryComponent,
    RptShipmentComponent,
    // Mobile page widget
    CreateMobilePageWidgetComponent,
    MobilePageWidgetListComponent,
    EditMobilePageWidgetComponent,
    SafeHtmlPipe,
    SinglePoReportComponent,
    MultiPoReportComponent,
    PopupNotificationComponent,
    PopupNotificationListComponent,
    EditPopupNotificationComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    CommonModule,
    ngfModule,
    HttpModule,
    NgMultiSelectDropDownModule.forRoot(),
    FormsModule,
   // CustomFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ImageCropperModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxEditorModule,
    DataTableModule,
    SelectDropDownModule,
    SelectModule,
    NgxSortableModule,
    DragulaModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    ModalModule.forRoot(),
    PaginationModule.forRoot(),
    ToastModule.forRoot(),
    TypeaheadModule.forRoot(),
    BsDatepickerModule.forRoot(),
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    RouterModule.forRoot([
      { path: '', component: HomeComponent, pathMatch: 'full' },
      { path: 'login', component: LoginComponent },
      { path: 'counter', component: CounterComponent },
      { path: 'fetch-data', component: FetchDataComponent },
      { path: 'products/:id', component: ProductListComponent },
      { path: 'faqs', component: FaqListComponent },
      { path: 'Create-System-Settings', component: CreateSettingComponent },
      { path: 'Edit-System-Settings/:id', component: EditSettingComponent, pathMatch: 'full' },
      { path: 'System-Settings-List', component: SettingListComponent },
      { path: 'faq-create', component: CreateFaqComponent },
      { path: 'faq-edit/:id', component: EditFaqComponent },
      { path: 'discount-types', component: DiscountTypeListComponent },
      { path: 'discount-type-create', component: CreateDiscountTypeComponent },
      { path: 'discount-type-edit/:id', component: EditDiscountTypeComponent },
      //{ path: 'coupon-types', component: CouponTypeListComponent },
      //{ path: 'coupon-type-create', component: CreateCouponTypeComponent },
      //{ path: 'coupon-type-edit/:id', component: EditCouponTypeComponent },
      { path: 'coupons', component: CouponsListComponent },
      { path: 'coupon-create', component: CreateCouponComponent },
      { path: 'coupon-edit/:id', component: EditCouponComponent },
      //{ path: 'coupon-category-products', component: CouponCategoryProductListComponent },
      //{ path: 'coupon-category-product-create', component: CreateCouponCategoryProductComponent },
      //{ path: 'coupon-category-product-edit/:id', component: EditCouponCategoryProductComponent },
      { path: 'Create-Parent-Category', component: CreateParentCategoryComponent },
      { path: 'Edit-Parent-Category/:id', component: EditParentCategoryComponent, pathMatch: 'full' },
      { path: 'edit-subcategory/:id', component: EditSubcategoryComponent },
      { path: 'Parent-Category-List', component: ParentCategoryListComponent },
      { path: 'create-product', component: CreateProductComponent },
      { path: 'edit-product/:id', component: EditProductComponent },
      { path: 'delete-product', component: DeleteProductComponent },
      { path: 'product-list', component: ProductListComponent },
      { path: 'customers', component: CustomerListComponent },
      { path: 'reset-password/:token', component: ResetPasswordComponent },
      { path: 'forgot-password', component: ForgotPasswordComponent },
      { path: 'customer-create', component: CreateCustomerComponent },
      { path: 'customer-edit/:type/:id', component: EditCustomerComponent },
      { path: 'vendors', component: CustomerDetailComponent },
      { path: 'Category-List', component: CategoryListComponent },
      { path: 'Create-Subcategory', component: CreateSubcategoryComponent },
      { path: 'Subcategory-List', component: SubcategoryListComponent },
      { path: 'edit-faq-category/:id', component: EditFaqCategoryComponent },
      { path: 'create-faq-category', component: CreateFaqCategoryComponent },
      { path: 'category-Fields', component: CategoryFieldsComponent },
      { path: 'faq-categories', component: FaqCategoryListComponent },
      { path: 'detail-faq-category/:id', component: DetailFaqCategoryComponent },
      { path: 'detail-faq/:id', component: DetailFaqComponent },
      { path: 'application-settings', component: UpdateApplicationSettingsComponent },
      { path: 'Subscribers', component: SubscriberListComponent },
      { path: 'edit-subscribers/:id', component: EditSubscribersComponent },
      { path: 'create-notification', component: CreateNotificationComponent },
      { path: 'notification-list', component: NotificationListComponent },
      { path: 'edit-notification/:id', component: EditNotificationComponent },
      { path: 'create-notification-event', component: CreateNotificationEventComponent },
      { path: 'notification-event-list', component: NotificationEventListComponent },
      { path: 'edit-notification-event/:id', component: EditNotificationEventComponent },
      { path: 'create-role', component: CreateRoleComponent },
      { path: 'edit-role/:id', component: EditRoleComponent },
      { path: 'role-list', component: RoleListComponent },
      { path: 'nav-menu', component: NavMenuComponent },
      { path: 'users', component: UserListComponent },
      { path: 'profile', component: ProfileViewComponent },
      { path: 'profile-update', component: ProfileUpdateComponent },
      { path: 'user-create', component: UserCreateComponent },
      { path: 'user-edit/:id', component: UserEditComponent },
      { path: 'push-notifications', component: PushNotificationComponent },
      { path: 'store-list', component: StoreListComponent },
      { path: 'create-brand', component: CreateBrandComponent },
      { path: 'brand-list', component: BrandListComponent },
      { path: 'edit-brand/:id', component: EditBrandComponent },
      { path: 'shipping-methods', component: ShippingMethodsListComponent },
      { path: 'create-announcement', component: CreateAnnouncementComponent },
      { path: 'edit-announcement/:id', component: EditAnnouncementComponent },
      { path: 'announcement-list', component: AnnouncementListComponent },
      { path: 'create-payment', component: CreatePaymentMethodComponent },
      { path: 'payment-list', component: PaymentMethodListComponent },
      { path: 'edit-payment/:id', component: EditPaymentMethodComponent },
      { path: 'create-action-notification', component: CreateActionNotificationComponent },
      { path: 'action-notification-list', component: ActionNotificationListComponent },
      { path: 'edit-action-notification/:id', component: EditActionNotificationComponent },
      { path: 'rating-list', component: RatingListComponent },
      { path: 'create-sale', component: CategorySalesComponent },
      { path: 'sale-list', component: CategorySalesListComponent },
      { path: 'edit-sales/:id', component: EditCategoryLevelSalesComponent },
      { path: 'create-EmailTemplate', component: CreateEmailTemplateComponent },
      { path: 'EmailTemplate-list', component: EmailTemplateListComponent }, 
      { path: 'edit-EmailTemplate/:id', component: EditEmailTemplateComponent },
      { path: 'create-BannerSlider', component: CreateBannerSliderComponent },
      { path: 'BannerSlider-list', component: BannerSliderListComponent },
      { path: 'edit-BannerSlider/:id', component: EditBannerSliderComponent },
      { path: 'order-list', component: OrderListComponent },
      { path: 'order-detail/:id', component: OrderDetailComponent },
      { path: 'order-list', component: OrderListComponent },
      { path: 'purchase-order-list', component: PurchaseOrderListComponent },
      { path: 'purchase-order-detail/:id', component: PurchaseOrderDetailComponent },
      { path: 'purchase-orders', component: PurchaseOrdersComponent },
      { path: 'order-detail/:id', component: OrderDetailComponent },
      { path: 'add-shipping-cost', component: AddShippingCostComponent },
      { path: 'create-blogcategory', component: CreateBlogCategoryComponent },
      { path: 'blogcategory-list', component: BlogcategoryListComponent },
      { path: 'edit-blogcategory/:id', component: EditBlogCategoryComponent },
      { path: 'create-blog', component: CreateBlogComponent },
      { path: 'blog-list', component: BlogListComponent },
      { path: 'edit-blog/:id', component: EditBlogComponent }, 
      { path: 'category-menu', component: CetogoryMenuComponent } ,
      { path: 'attribute', component: AttributesComponent },
      { path: 'slug/:id', component: SlugComponent },
      { path: 'create-page', component: CreatePageComponent },
      { path: 'page-list', component: PageListComponent },
      { path: 'edit-page/:id', component: EditPageComponent },
      { path: 'SupplierTicket-list', component: SupplierTicketListComponent }, 
      { path: 'manage-url-redirection', component: ManageUrlRedirectionComponent }, 
      { path: 'role-permissions/:id', component: RolePermissionsComponent } ,
      { path: 'role-permissions/:id', component: RolePermissionsComponent },
      { path: 'settingShipmentRules-list', component: SettingShipmentRulesListComponent },
      { path: 'media-list', component: MediaLibraryListComponent },

      { path: 'edit-simple-product/:id', component: EditSimpleProductComponent },
      { path: 'edit-draft-product/:id', component: EditDraftProductComponent },
      
      { path: 'edit-single-veriable-product/:master/:id', component: EditProductComponent },
      { path: 'edit-variable-product/:id', component: EditVariableProductComponent },
      { path: 'create-page-widget', component: CreatePageWidgetComponent },
      { path: 'page-widget-list', component: PageWidgetListComponent },
      { path: 'create-shippment', component: CreateShippingMethodComponent }, 
      { path: 'edit-shippment/:id', component: EditShippmentMethodComponent }, 
      { path: 'product-import', component: ProductImportComponent},
      { path: 'site-maps', component: SiteMapsComponent },
      { path: 'create-menu', component: CreateManuManagementComponent },
      { path: 'manu-list', component: ManuManagementListComponent },
      { path: 'edit-menu/:id', component: EditMenuManagementComponent },
      { path: 'manage-finance', component: FinanceManagementListComponent },
      { path: 'withdrawals', component: WithdrawalRequestComponent },
      { path: 'withdrawal-details/:id', component: WithdrawalDetailsComponent },
      { path: 'parent-sort-widgets', component: ParentSortWidgetsComponent },
      { path: 'edit-page-widget/:id', component: EditPageWidgetComponent },
      { path: 'warranty-edit/:id', component: WarrantyEditComponent },
      { path: 'warranty-list', component: WarrantyTypeListComponent },
      { path: 'warranty-create', component: WarrantyCreateComponent },
      { path: 'returnPolicy-edit/:id', component: ReturnPolicyEditComponent },
      { path: 'returnPolicy-list', component: ReturnPolicyListComponent }, 
      { path: 'rpt-vendor', component: RptVendorsComponent }, 
      { path: 'returnPolicy-create', component: ReturnPolicyCreateComponent },  
      { path: 'rpt-sales', component: RptSalesComponent },
      { path: 'rpt-search-history', component: RptSearchHistoryComponent }, 
      { path: 'rpt-customer-orders', component: RptCustomerOrdersComponent },  
      { path: 'rpt-shipment', component: RptShipmentComponent },
      { path: 'rpt-customer', component: RptCustomerComponent },
      // Mobile Page widget
      { path: 'create-mobile-page-widget', component: CreateMobilePageWidgetComponent },
      { path: 'edit-mobile-page-widget/:id', component: EditMobilePageWidgetComponent },
      { path: 'mobile-page-widget-list', component: MobilePageWidgetListComponent },
      { path: 'single-PO-Report', component: SinglePoReportComponent },
      { path: 'multi-PO-Report', component: MultiPoReportComponent },
      { path: 'create-popupNotification', component: PopupNotificationComponent },
      { path: 'popupNotification-list', component: PopupNotificationListComponent },
      { path: 'popupNotofocation-edit/:id', component: EditPopupNotificationComponent },
      
    ])
  ],
  providers: [
    HomeService,
    SystemSettingService,
    GenericService,
    FaqService,
    CategoryService,
    ProductService,
    DiscountTypeService,
    //CouponTypeService,
    CouponsService,
    SiteMapsService,
    CustomerService,
    PagerService,
    FaqCategoryService,
    NotificationService,
    NotificationEventService,
    RoleService,
    RolePermissionService,
    UserService,
    ApplicationSettingsService,
    UtilitiesService,
    LoginService,
    CountryService,
    CookieService,
    AppService,
    SubscriberService,
    PushNotificationService,
    PurchaseOrderService,
    StoreService,
    BrandService,
    ShippmentService,
    ProfileService,
    StateService,
    AnnouncementService,
    PaymentService,
    ActionNotificationService,
    RatingService,
    OrderService,
    BlogCategoryService,
    EmailTemplateService,
    BannerSliderService,
    OrderService,
    ShippingCostService,
    EmailTemplateService,
    BannerSliderService,
    OrderService,
    ShippingCostService,
    OrderService,
    BlogCategoryService,
    PageService,
    SupplierTicketService,
    UrlRedirectionService,
    SettingShipmentRulesService,
    WidgetService,
    MediaLibraryService,
    ManuManagementService,
    WithdrawlsService,
    ReportService,
    MobilewidgetService
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts